'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var __assign = undefined && undefined.__assign || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var customWindow = exports.customWindow = window;
var getLocationMock = exports.getLocationMock = function getLocationMock(fieldsToOverwrite) {
    return __assign({ ancestorOrigins: {
            length: 0,
            contains: function contains() {
                return false;
            },
            item: function item() {
                return null;
            }
        }, hash: '', host: '', hostname: '', href: '', origin: '', pathname: '', port: '', protocol: '', search: '', assign: function assign() {
            return undefined;
        }, reload: function reload() {
            return undefined;
        }, replace: function replace(url) {
            return undefined;
        } }, fieldsToOverwrite);
};
var setEnvTo = exports.setEnvTo = function setEnvTo(domain) {
    delete window.location;
    window.location = getLocationMock({
        hostname: "90seconds." + domain
    });
};
var setHostNameToUndefined = exports.setHostNameToUndefined = function setHostNameToUndefined() {
    delete window.location;
    window.location = getLocationMock({
        hostname: undefined
    });
};
var setHostNameToUnsupportedDomain = exports.setHostNameToUnsupportedDomain = function setHostNameToUnsupportedDomain() {
    delete window.location;
    window.location = getLocationMock({
        hostname: '90seconds.something_else'
    });
};
var setHostnameTo = exports.setHostnameTo = function setHostnameTo(hostname, assignMock) {
    var oldWindowLocation = window.location;
    delete window.location;
    window.location = getLocationMock({
        hostname: hostname,
        assign: assignMock || oldWindowLocation.assign
    });
};
var setMockHostnameTo = exports.setMockHostnameTo = function setMockHostnameTo(hostname) {
    customWindow.mockHostname = hostname;
};
var setMockDomainTo = exports.setMockDomainTo = function setMockDomainTo(domain) {
    customWindow.mockDomain = domain;
};
var setMockUserTo = exports.setMockUserTo = function setMockUserTo(user) {
    customWindow.mockUser = user;
};
//# sourceMappingURL=window.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/test-helpers/mock/window.js
// module id = 968
// module chunks = 0